import { Expose } from "class-transformer";
import { safeAssign } from "./safe-assign";

export class SessionDTO {
    @Expose()
    id: number;
    @Expose()
    token: string;
    @Expose()
    accountId: number;
    @Expose()
    companyId?: number;
    @Expose()
    scope: string;

    constructor(props: SessionDTO) {
        safeAssign<SessionDTO>(this, props);
    }
}
